import { FC, useMemo } from 'react';
import { AgentModel } from '@/lib/models/agent.model';
import UsageCard from '../usage-card';
import AgentLink from '../agent-link';
import { UsageItem } from '../usage-card/helpers';

interface Props {
  agents: AgentModel[];
}

const AgentUsageCard: FC<Props> = ({ agents }) => {
  const items = useMemo(() => {
    return agents.map((agent) => {
      const usageItem: UsageItem = {
        id: agent.id,
        EntityLinkEl: <AgentLink agent={agent} size="small" variant="outlined" canNavigate />,
      };
      return usageItem;
    });
  }, [agents]);

  return <UsageCard title="Assistants" items={items} icon="assistant" />;
};

export default AgentUsageCard;
